import { InjectionToken } from '@angular/core';

export interface BFFConfig {
  BFF: {
    ApiUrl: string;
  };
}

export const BFF_CONFIG = new InjectionToken<BFFConfig>('configuration');

const DEFAULT_BFF_CONFIG: BFFConfig = {
  BFF: {
    ApiUrl: '',
  },
};

export function getBFFConfigWithDefaults(config?: BFFConfig): BFFConfig {
  return { ...DEFAULT_BFF_CONFIG, ...config } as BFFConfig;
}
